export class PlayerBiometricConnection {
    constructor(options) {
        this.apiUrl = options.apiUrl;
        this.consumerVersion = options.consumerVersion || "";
        this.abortController = new AbortController();
    }
    getData(playerId) {
        this.abortController = new AbortController();
        return this.executeRequest(this.getRequest(playerId));
    }
    cancel() {
        this.abortController.abort();
    }
    getRequest(playerId) {
        return new Request(`${this.apiUrl}${playerId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "X-Client-Name": "web",
                "X-Client-Version": this.consumerVersion,
                "X-Client-Feature": "player-page",
                "X-Client-Page": "player",
                "X-Client-Widget-Name": "PlayerPageWidget",
                "X-Client-Widget-Version": VERSION,
            }
        });
    }
    executeRequest(request) {
        return fetch(request, {
            signal: this.abortController.signal
        }).then(response => response.json());
    }
}
//# sourceMappingURL=PlayerBiometricConnection.js.map